import axios from '../utils/axios';
import get from 'lodash/get';

const resolveUrlParameters = (path, urlParams) => {
  if (!urlParams) {
    return path;
  }
  Object.keys(urlParams).forEach(urlParam => {
    path = path.replace(`:${urlParam}`, urlParams[urlParam]);
  });

  return path;
};

const request = async ({ host, urlParams, queryParams, path, body, headers, method = 'GET' }) => {
  try {
    const modifiedHeaders = headers ? { ...headers } : {};
    modifiedHeaders['Content-Type'] = modifiedHeaders['Content-Type'] || 'application/json';

    const resolvedPath = resolveUrlParameters(path, urlParams);
    const isLoginTypeSSO = () => {
      let loginType = localStorage.getItem('loginType');
      if (!loginType) {
        return false;
      }
      try {
        loginType = JSON.parse(loginType);
        return loginType === 'sso';
      } catch (error) {
        return false;
      }
    };
    const options = {
      method,
      headers: modifiedHeaders,
      data: body,
      params: queryParams,
      // url: resolvedPath,
      url: host ? `${host}${resolvedPath}` : `${process.env.REACT_APP_SERVER_BASE_URL}${resolvedPath}`,

      withCredentials: true // TODO
    };
    if (isLoginTypeSSO()) {
      options.headers = { ...options.headers } || {};
      options.headers.xsignintype = 'sso';
    }
    const response = await axios(options);
    return response;
  } catch (error) {
    if (error.response) {
      // client received an error response (5xx, 4xx)
      const err = new Error();
      err.status = get(error, 'response.status', 500);
      err.body = get(error, 'response.data');
      err.message = get(error, 'response.data.message', 'Something went wrong');
      throw err;
    } else if (error.request) {
      // client never received a response, or request never left
      throw new Error(error.message || 'Network error');
    } else {
      // anything else
      throw new Error(error.message || 'Something went wrong. Please try again.');
    }
  }
};

export default request;
